import React from 'react';

const DashboardPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-neutral-darker p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-primary mb-8">Dashboard</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Enrolled Courses Card */}
          <div className="bg-neutral-dark rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-semibold text-primary mb-4">Enrolled Courses</h2>
            <p className="text-neutral-light">You are not enrolled in any courses yet.</p>
          </div>

          {/* Progress Card */}
          <div className="bg-neutral-dark rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-semibold text-primary mb-4">Learning Progress</h2>
            <p className="text-neutral-light">Start a course to track your progress.</p>
          </div>

          {/* Achievements Card */}
          <div className="bg-neutral-dark rounded-lg shadow-lg p-6">
            <h2 className="text-xl font-semibold text-primary mb-4">Achievements</h2>
            <p className="text-neutral-light">Complete courses to earn achievements.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage; 